<template>
  <customFieldsAddingPreview
    :icon='"phone-call.svg"'
    :name="preloadedItem.name || 'Phone Number'">

    <template :slot='"body"'>
      <v-text-field
        dense
        v-model="value"
        :placeholder="preloadedItem.placeholder || ''"
        v-mask="'+# (###) ### ##-##'"
        :rules='phoneRules'/>
    </template>
  </customFieldsAddingPreview>
</template>

<script>
import customFieldsAddingPreview from '../customFieldsAddingPreview'
export default {
  props: {
    preloadedItem: {
      type: Object,
      default: () => {
        return {
          name: '',
          placeholder: '',
          defaultValue: null
        }
      }
    }
  },
  data: function() {
    return {
      value: this.preloadedItem.defaultValue,
      phoneRules: [v => { return true }]
    }
  },
  watch: {
    'preloadedItem.defaultValue': {
      handler (newDefaultValue) {
        this.value = newDefaultValue
      },
      deep: true
    }
  },
  components: {
    customFieldsAddingPreview
  }
}
</script>

<style lang="scss">
  .flag-phone {
    display: none;
  }
  .wrraper-phone {
    display: flex;
    width: 100%;
  }
  .input-phone {
    width: 100%;
    height: 45px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    outline: none !important;
  }
  .input-phone:hover {
    border-bottom: 1px solid rgba(0, 0, 0, 0.87);
  }
  .input-phone:focus {
    border-bottom: 1px solid rgba(0, 0, 0, 0.87);
  }
</style>
